<div class="container-fixed-header" [ngClass]="{'mobile-app-view': mobileAppView}">
  <ul class="list-inline">
    <li><a (click)="moveTo('fulfillFlight')"
           href="javascript:void(0)">Fulfill Flights</a></li>
  </ul>
</div>

<div class="landing-content bg-white">
  <div class="cover-photo"
       style="background: url(assets/img/landing-header-2x.jpg) no-repeat 50% bottom/cover;"></div>

  <div class="container">
    <!-- START FULFILL FLIGHT ROW -->
    <div class="row">
      <div class="col-lg-6 col-sm-12 d-flex flex-column fulfill-flights">
        <h3>Fulfill Flights</h3>
        <p id="fulfillFlight"
           class="m-b-100">
          At XO, we are dedicated to eliminating all of the hassles of booking a private jet. We are committed to
          bringing efficiency and value to both our operators and customers. In keeping with this philosophy, our
          Fulfill Flights feature allows you to automatically receive confirmed trip requests directly from our
          customers or submit offers digitally for flights requested by vetted and verified private
          charter customers.
        </p>
      </div>
    </div>
  </div>
</div>
